import classNames from "classnames";
import withStyles from "isomorphic-style-loader/withStyles";
import moment from "moment";
import { ScaleLoader } from "react-spinners";
import { AiChatSessionSummary } from "../../../../types/services/IAiChatSession";
import s from "./styles.scss";

interface Props {
  sessions: AiChatSessionSummary[];
  loading: boolean;
  error: string | null;
  activeSessionId?: string;
  isDraft?: boolean;
  onSessionSelect: (sessionId: string) => void;
}

function formatSessionDate(createdAt: string): string {
  const date = moment(createdAt);
  if (!date.isValid()) {
    return "";
  }
  return date.format("MMM D, YYYY");
}

function ChatSessionList({
  sessions,
  loading,
  error,
  activeSessionId,
  isDraft = false,
  onSessionSelect,
}: Props) {
  if (loading) {
    return (
      <div className={s.listState}>
        <ScaleLoader color="#1f65b1" height={20} width={3} loading />
      </div>
    );
  }

  if (error) {
    return <div className={s.listError}>{error}</div>;
  }

  if (sessions.length === 0 && !isDraft) {
    return (
      <div className={s.listState}>
        No conversations yet. Use + to start one.
      </div>
    );
  }

  return (
    <>
      {isDraft && (
        <div
          className={classNames(s.sessionRow, s.sessionRowActive, s.draftRow)}
          data-elm-id="chatSessionDraftRow"
        >
          <p className={s.sessionPreview}>New chat</p>
          <p className={s.sessionDate}>Draft</p>
        </div>
      )}
      {sessions.map(session => (
        <button
          key={session.sessionId}
          type="button"
          className={classNames(
            s.sessionRow,
            session.sessionId === activeSessionId && s.sessionRowActive
          )}
          onClick={() => onSessionSelect(session.sessionId)}
          data-elm-id={`chatSessionRow-${session.sessionId}`}
        >
          <p className={s.sessionPreview}>{session.preview}</p>
          <p className={s.sessionDate}>{formatSessionDate(session.createdAt)}</p>
        </button>
      ))}
    </>
  );
}

export default withStyles(s)(ChatSessionList);
